import React from 'react';
import Loader from '../common/Loader';
import { useFetchPrematchMenu } from '../data/fetchMenuPrematch';

export const PrematchDataContext = React.createContext(null);

function PrematchDataFetcher(props) {
    const [state] = useFetchPrematchMenu();

    if (state.isLoading || state.isError) {
        return <Loader error={state.isError} />;
    }

    return (
        <PrematchDataContext.Provider value={state.data}>
            {props.children}
        </PrematchDataContext.Provider>
    );
}

export default PrematchDataFetcher;